export default __webpack_public_path__ + "static/media/livingroom3.c4cfc5bd.jpg";